import { Directive, ElementRef, HostListener, Inject, InjectionToken, Input, Optional, SkipSelf } from '@angular/core';
import { APP_RESIZABLE_PARENT, IAppResizable } from './resizable-parent';

export const APP_RESIZE_HANDLE = new InjectionToken<ResizeHandleDirective>('APP_RESIZE_HANDLE');

@Directive({
  selector: '[appResizeHandle]',
  host: {
        'class': 'app-resize-handle',
        '[class.app-resize-handle-dragging]': 'dragging',
    },
    providers: [{
            provide: APP_RESIZE_HANDLE,
            useExisting: ResizeHandleDirective
        }],
  standalone: false
})
export class ResizeHandleDirective {
  @Input() resizeDirection: 'horizontal' | 'vertical' | 'both' = 'both';
  @Input() invertX = false;
  @Input() invertY = false;

  dragging = false;
  dragX = 0;
  dragY = 0;

  constructor(
    public element: ElementRef<HTMLElement>,
    @Inject(APP_RESIZABLE_PARENT) @Optional() @SkipSelf() private resizable: IAppResizable) {
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (event.button === 0) {
      this.dragging = true;

      this.dragX = event.pageX;
      this.dragY = event.pageY;

      this.resizable.beginResize();
    }
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.dragging) {
      let canResizeBoth = this.resizeDirection == 'both';
      let canResizeX = canResizeBoth || (this.resizeDirection == 'horizontal');
      let canResizeY = canResizeBoth || (this.resizeDirection == 'vertical');

      let dx = canResizeX ? (event.pageX - this.dragX) : 0;
      let dy = canResizeY ? (event.pageY - this.dragY) : 0;

      this.dragX = event.pageX;
      this.dragY = event.pageY;

      if (this.invertX) dx = -dx;
      if (this.invertY) dy = -dy;

      this.resizable.resize(dx, dy);
    }
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    if (event.button === 0) {
      if (this.dragging) {
        this.resizable.endResize();

        this.dragging = false;
      }
    }
  }
};
